import { css } from 'styled-components';
import { getSpacing, SpacingName, ThemedFunctor } from '@doveit/bricks';

export const item: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.SMALLER)}

  &:first-of-type {
    margin-top: 0;
  }
`;
